import { render, staticRenderFns } from "./CreateCampaignSourceCollection.vue?vue&type=template&id=5d9c3718&scoped=true"
import script from "./CreateCampaignSourceCollection.vue?vue&type=script&lang=js"
export * from "./CreateCampaignSourceCollection.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignSourceCollection.vue?vue&type=style&index=0&id=5d9c3718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9c3718",
  null
  
)

export default component.exports